import { App } from '../../types'
import Config from '../../config'

export const calculateSupportedDomain = (apps: App[]) => {
    const tabDomain: string = window.location.host
    return (
        process.env.NODE_ENV === 'development' ||
        apps.some(({ domains }: { domains: string[] }) =>
            domains.some((domain: string) => tabDomain.includes(domain))
        )
    )
}
export const checkActivePage = (path: string) =>
    window.location.href.includes(
        `https://${Config.firebase.authDomain}${path}`
    )
